<template>
  <el-row>
    <el-row>
      <el-dialog
        title="分离方法信息"
        :visible.sync="showDetailDialog"
        width="80%"
      >
        <el-row>
          <el-button
            type="primary"
            @click="editInfos(detailForm)"
            v-if="showState"
            >修改</el-button
          >
        </el-row>
        <el-row>
          <SearchMethodsDetail
            v-bind:sepaMethods="detailForm"
          ></SearchMethodsDetail>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <h3>查看分离方法</h3>
      <el-col :span="22">
        <el-form label-width="120px" :model="searchCondition">
          <el-row>
            <el-col :span="10">
              <el-form-item label="选择时间：">
                <el-date-picker
                  size="small"
                  v-model="searchCondition.timeRange"
                  type="datetimerange"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="10" :offset="2">
                            <el-form-item label="项目名称:">
                                <el-input v-model="searchCondition.projectName" size="small" maxlength="300"></el-input>
                            </el-form-item>
                        </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="起始化合物: ">
                <el-input
                  v-model="searchCondition.startObjectName"
                  size="small"
                  maxlength="100"
                  @input="inputStartChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <el-button type="primary" size="mini" @click="openStart"
                  >结构式</el-button
                >
                <el-dialog
                  custom-class="dialog"
                  :visible.sync="dialogVisible"
                  :close-on-click-modal="false"
                  :append-to-body="true"
                  v-loading="onLoading"
                >
                  <iframe
                    style="display:'block',margin:'0 auto'"
                    id="ifKetcher"
                    name="molview"
                    width="784"
                    height="624"
                    src="./iframe/index.html"
                    :onload="onloaded()"
                  ></iframe>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="uploadStart"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div
                style="height: 150px; width: 220px; margin: 40px 0 0 0"
                v-if="this.startUrl != ''"
              >
                <img
                  :src="'data:image/png;base64,' + this.startUrl"
                  class="img-url"
                />
              </div>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-form-item label="目标化合物: ">
                <el-input
                  v-model="searchCondition.targetObjectName"
                  size="small"
                  maxlength="100"
                  @input="inputChange"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <el-button type="primary" size="mini" @click="openTarget"
                  >结构式</el-button
                >
                <el-dialog
                  custom-class="dialog"
                  :visible.sync="dialogTartgetVisible"
                  :close-on-click-modal="false"
                  :append-to-body="true"
                  v-loading="onLoading"
                >
                  <iframe
                    style="display:'block',margin:'0 auto'"
                    id="ifKetcherTarget"
                    name="molview"
                    width="784"
                    height="624"
                    src="./iframe/index.html"
                    :onload="onTargetloaded()"
                  ></iframe>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogTartgetVisible = false"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="uploadTarget"
                      >确 定</el-button
                    >
                  </div>
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div
                style="height: 150px; width: 220px; margin: 40px 0 0 0"
                v-if="this.targetUrl != ''"
              >
                <img
                  :src="'data:image/png;base64,' + this.targetUrl"
                  class="img-url"
                />
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="状态:">
                <el-select
                  v-model="searchCondition.uploadState"
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in uploadStateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-form-item label="机构名称: ">
                <el-input
                  v-model="searchCondition.deptName"
                  size="small"
                  maxlength="100"
                  @input="inputnDeptNameChange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button
        type="primary"
        @click="searchSepeMethods"
        icon="el-icon-refresh"
        >搜索</el-button
      >
      <el-button @click="resetForm">重置</el-button>
    </el-row>
    <el-row v-loading="loading">
      <el-table
        :data="
          table.filter(
            (data) =>
              !search ||
              data.infos.SampleInfo.Project.toLowerCase().includes(
                search.toLowerCase()
              )
          )
        "
      >
        <el-table-column label="目标物名称" prop="toName"></el-table-column>
        <el-table-column label="CAS号" prop="toCas"></el-table-column>
        <el-table-column label="结构式" prop="samplePic">
          <template slot-scope="scope">
            <div v-if="scope.row.samplePic != ''">
              <img
                :src="'data:image/png;base64,' + scope.row.samplePic"
                width="100px"
                style="border: 1px solid #ebebed"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            <div>{{ formatTime(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="机构名称" prop="deptName" width="120">

        </el-table-column>
        <el-table-column label="申请状态" prop="status">
          <template slot-scope="props">
            <p v-if="props.row.status == 4">已上架</p>
            <p v-if="props.row.status == 3" style="color: #f56c6c">被驳回</p>
            <p v-if="props.row.status == 2" style="color: #67c23a">已通过</p>
            <p v-if="props.row.status == 1" style="color: #e6a23c">审核中</p>
            <p v-if="props.row.status == 0">未上传</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="550">
          <template slot-scope="props">
            <el-link
              type="primary"
              @click="

                setDetailForm(
                  props.row.infos,
                  props.row.status,
                  props.row.id,
                )
              "
              style="margin-right: 25px"
              >详情</el-link
            >
            <el-link
              type="primary"
              v-if="props.row.status == 0"
              @click="updateMethodState(props.row.id, 1)"
              style="margin-right: 25px"
              >上传</el-link
            >
            <el-link
              type="primary"
              v-if="props.row.status == 4"
              @click="updateMethodState(props.row.id, 2)"
              style="margin-right: 25px"
              >下架</el-link
            >
            <el-link
              type="warning"
              v-if="props.row.status == 2"
              @click="updateMethodState(props.row.id, 4)"
              style="margin-right: 25px"
              >上架</el-link
            >
            <el-link
              type="primary"
              v-if="props.row.status == 3"
              @click="openMsg(props.row.refuseMsg)"
              style="margin-right: 25px"
              >驳回原因</el-link
            >
            <el-link
              type="danger"
              v-if="props.row.status != 4 && props.row.status != 1"
              @click="deleteSepMethods(props.row.id)"
              style="margin-right: 25px"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, prev, pager, next"
        @current-change="pageChange"
      ></el-pagination>
    </el-row>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
import SearchMethodsDetail from "./search/SearchMethodsDetail";
import moment from "moment";
export default {
  name: "SearchSepeMethods",
  components: {
    SearchMethodsDetail,
  },
  data() {
    return {
      tipContent: "",
      dialogVisible: false,
      dialogTartgetVisible: false,
      canPublish: false,
      loading: false,
      onLoading: false,
      startUrl: "",
      targetUrl: "",
      table: [],
      page: 1,
      pageSize: 10,
      totalSize: 10,
      showDetailDialog: false,
      showState: false,
      search: "",
      analysisMethodType: this.$store.state.sepaMethods.analysisMethodType,
      uploadStateOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "待上传",
        },
        {
          value: "1",
          label: "审核中",
        },
        {
          value: "2",
          label: "已通过",
        },
        {
          value: "3",
          label: "被驳回",
        },
        {
          value: "4",
          label: "已上架",
        },
      ],
      detailForm: {
        SampleInfo: {
          Project: "",
        },
        startObjects: {
          name: "",
          cas: "",
          png: "",
        },
        SolventList: [
          {
            Solvent: "",
            Percent: "",
            Polarity: "",
            id: "",
            Density: "",
          },
          {
            Solvent: "",
            Percent: "",
            Polarity: "",
            id: "",
            Density: "",
          },
        ],
        RFList: [],
        FlowRateList: [],
        GradientList: [],
        MethodInfo: {
          sampleWeight: "",
          flashColumn: "",
        },
        sampleAnalysis: {
          hplc: {
            flashColumn: {
              aperture: "120A",
              particleSize: "5um",
              spec: "4.6 * 250",
              type: 1,
            },
            flowPhase: [],
            gradientList: [
              {
                PercentA: "",
                PercentB: "",
                PercentC: "",
                PercentD: "",
                cV: "",
                time: "",
              },
            ],
            hplcPic: "",
            targetPurity: "",
            targetSaveTime: "",
          },
          tlc: {
            solvents: [
              {
                Percent: "",
                Solvent: "",
              },
            ],
            tlc: 1,
            tlcPic: "",
          },
          type: 1,
        },
      },
      searchCondition: {
        deptName: "",
        timeRange: [],
        projectName: "",
        targetObjectName: "",
        startObjectName: "",
        uploadState: "",
      },
    };
  },
  methods: {
    //驳回原因提示
    openMsg(refuseMsg) {
      this.$alert(`${refuseMsg}`, "驳回原因", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.$message({
            type: "info",
            message: `action: ${action}`,
          });
        },
      });
    },
    resetMinDate() {
      if (
        this.searchCondition.timeRange &&
        this.searchCondition.timeRange.length &&
        this.minDate &&
        !this.maxDate
      ) {
        this.minDate = new Date(this.searchCondition.timeRange[0]);
      } else {
        this.minDate = null;
      }
    },
    onloaded: function () {},
    async uploadStart() {
      try {
        let ketcherFrame = document.getElementById("ifKetcher");
        let ketcher = ketcherFrame.contentWindow.ketcher;

        let smile = await ketcher.getSmiles();
        let origin_image = await ketcher.generateImage(smile, {
          outputFormat: "png", // 生成图片的类型，可以是"svg"或"png"
          backgroundColor: "255, 255, 255",
        });
        let url = URL.createObjectURL(origin_image);
        let image = document.createElement("img");
        image.src = url;
        image.onload = () => {
          let w = image.width;
          let h = image.height;
          let w1 = Number(((image.height / 7) * 12).toFixed(0));
          let h1 = Number(((image.width / 12) * 7).toFixed(0));
          let canvas_w = Math.max(w, w1);
          let canvas_h = Math.max(h, h1);
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = canvas_w;
          canvas.height = canvas_h;
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas_w, canvas_h);
          ctx.drawImage(image, (canvas_w - w) / 2, (canvas_h - h) / 2, w, h);
          let png = canvas.toDataURL("image/png");
          let imageUrl = png;
          imageUrl = imageUrl
            .substring(imageUrl.indexOf(",") + 1)
            .replaceAll(" ", "+");
          this.startUrl = imageUrl;
          this.searchCondition.startObjectName = smile;
          this.dialogVisible = false;
        };
      } catch (e) {
        //   message.error({content:'Error'})
        //   setLoading(false)
      }
    },
    openStart() {
      this.dialogVisible = true;
      this.onLoading = true;
      setTimeout(() => {
        this.onLoading = false;
      }, 2000);
    },
    onTargetloaded: function () {},
    async uploadTarget() {
      try {
        let ketcherFrame = document.getElementById("ifKetcherTarget");
        let ketcher = ketcherFrame.contentWindow.ketcher;

        let smile = await ketcher.getSmiles();
        let origin_image = await ketcher.generateImage(smile, {
          outputFormat: "png", // 生成图片的类型，可以是"svg"或"png"
          backgroundColor: "255, 255, 255",
        });
        let url = URL.createObjectURL(origin_image);
        let image = document.createElement("img");
        image.src = url;
        image.onload = () => {
          let w = image.width;
          let h = image.height;
          let w1 = Number(((image.height / 7) * 12).toFixed(0));
          let h1 = Number(((image.width / 12) * 7).toFixed(0));
          let canvas_w = Math.max(w, w1);
          let canvas_h = Math.max(h, h1);
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = canvas_w;
          canvas.height = canvas_h;
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas_w, canvas_h);
          ctx.drawImage(image, (canvas_w - w) / 2, (canvas_h - h) / 2, w, h);
          let png = canvas.toDataURL("image/png");
          let imageUrl = png;
          imageUrl = imageUrl
            .substring(imageUrl.indexOf(",") + 1)
            .replaceAll(" ", "+");
          this.targetUrl = imageUrl;
          this.searchCondition.targetObjectName = smile;
          this.dialogTartgetVisible = false;
        };
      } catch (e) {
        //   message.error({content:'Error'})
        //   setLoading(false)
      }
    },
    openTarget() {
      this.dialogTartgetVisible = true;
      this.onLoading = true;
      setTimeout(() => {
        this.onLoading = false;
      }, 2000);
    },
    searchSepeMethods: function () {
      this.loading = true;
      this.getSepeMethods();
      this.getMethodsCount();
    },
    resetForm() {
      this.searchCondition = {
        timeRange: [],
        projectName: "",
        targetObjectName: "",
        startObjectName: "",
        uploadState: "",
        deptName: "",
      };
      this.targetUrl = "";
      this.startUrl = "";
      this.getSepeMethods();
      this.getMethodsCount();
    },
    genMethodsSearchCondition: function () {
      let conditionJSON = {};
      if (this.searchCondition.timeRange != null && this.searchCondition.timeRange.length === 2) {
        // 确保时间格式为字符串格式
        conditionJSON.startTime = this.searchCondition.timeRange[0];
        conditionJSON.endTime = this.searchCondition.timeRange[1];
      }
      if (this.searchCondition.targetObjectName != "") {
        conditionJSON.TOName = this.searchCondition.targetObjectName;
      }
      if (this.searchCondition.startObjectName != "") {
        conditionJSON.SOName = this.searchCondition.startObjectName;
      }
      if (this.searchCondition.projectName != "") {
        conditionJSON.ProjectName = this.searchCondition.projectName;
      }
      if (this.searchCondition.uploadState != "") {
        conditionJSON.status = this.searchCondition.uploadState;
      }
      if (this.searchCondition.deptName != "") {
        conditionJSON.deptName = this.searchCondition.deptName;
      }
      return conditionJSON;
    },
    getSepeMethods: function () {
      let _this = this;
      let conditionJSON = this.genMethodsSearchCondition();
      let username = this.$cookie.get("userId");
      this.$api.post(
        "/datacenter/getSepaMethodsByUser",
        {
          page: this.page,
          pageSize: this.pageSize,
          username: username,
          condition: conditionJSON,
        },
        (res) => {
          _this.loading = false;
          if (res.data.code == 200) {
            _this.table = res.data.data.map((detail) => {
              console.log('res.data',res.data)
              let startobject = [];
              if (
                detail.methodDetailInfo.methodSampleInfo.reactant_sample_list !=
                null
              ) {
                if (
                  detail.methodDetailInfo.methodSampleInfo.reactant_sample_list
                    .length != 0
                ) {
                  for (
                    let i = 0;
                    i <
                    detail.methodDetailInfo.methodSampleInfo
                      .reactant_sample_list.length;
                    i++
                  ) {
                    startobject.push({
                      cas: detail.methodDetailInfo.methodSampleInfo
                        .reactant_sample_list[i].sample_cas_info,
                      name: detail.methodDetailInfo.methodSampleInfo
                        .reactant_sample_list[i].sample_name,
                      png: detail.methodDetailInfo.methodSampleInfo
                        .reactant_sample_list[i].sample_pic,
                      smile:
                        detail.methodDetailInfo.methodSampleInfo
                          .reactant_sample_list[i].sample_smiles,
                    });
                  }
                } else {
                  startobject.push({
                    cas: "",
                    name: "",
                    png: "",
                    smile: "",
                  });
                }
              } else {
                startobject.push({
                  cas: "",
                  name: "",
                  png: "",
                  smile: "",
                });
              }
              let solventsList = [
                {
                  Solvent: "",
                  Percent: "",
                  Polarity: "",
                  Density: "",
                  id: "",
                },
                {
                  Solvent: "",
                  Percent: "",
                  Polarity: "",
                  Density: "",
                  id: "",
                },
              ];
              if (detail.methodDetailInfo.methodTLCInfo != null) {
                if (
                  detail.methodDetailInfo.methodTLCInfo
                    .projectExpaSolventInfoList.length != 0
                ) {
                  solventsList = [];
                  for (
                    let i = 0;
                    i <
                    detail.methodDetailInfo.methodTLCInfo
                      .projectExpaSolventInfoList.length;
                    i++
                  ) {
                    solventsList.push({
                      Solvent:
                        detail.methodDetailInfo.methodTLCInfo
                          .projectExpaSolventInfoList[i].solvent,
                      Percent:
                        detail.methodDetailInfo.methodTLCInfo
                          .projectExpaSolventInfoList[i].percent,
                      Polarity:
                        detail.methodDetailInfo.methodTLCInfo
                          .projectExpaSolventInfoList[i].polarity,
                      Density:
                        detail.methodDetailInfo.methodTLCInfo
                          .projectExpaSolventInfoList[i].density,
                      id: detail.methodDetailInfo.methodTLCInfo
                        .projectExpaSolventInfoList[i].solvent_id,
                    });
                  }
                }
              }

              let rfInfo = [];
              if (detail.methodDetailInfo.methodTLCInfo != null) {
                if (
                  detail.methodDetailInfo.methodTLCInfo.methodTLCRFInfoList
                    .length > 0
                ) {
                  for (
                    let i = 0;
                    i <
                    detail.methodDetailInfo.methodTLCInfo.methodTLCRFInfoList
                      .length;
                    i++
                  ) {
                    rfInfo.push({
                      Value:
                        detail.methodDetailInfo.methodTLCInfo
                          .methodTLCRFInfoList[i].value,
                      RFFlag:
                        detail.methodDetailInfo.methodTLCInfo
                          .methodTLCRFInfoList[i].rfflag,
                      level: `Rf${i + 1}`,
                    });
                  }
                }
              }
              let hplcInfo = [];
              if (detail.methodDetailInfo.methodHPLCInfo != null) {
                for (
                  let i = 0;
                  i <
                  detail.methodDetailInfo.methodHPLCInfo.methodHPLCRTInfoList
                    .length;
                  i++
                ) {
                  hplcInfo.push({
                    Area: detail.methodDetailInfo.methodHPLCInfo
                      .methodHPLCRTInfoList[0].area,
                    ComponentIndex:
                      detail.methodDetailInfo.methodHPLCInfo
                        .methodHPLCRTInfoList[0].component_index,
                    TFlag:
                      detail.methodDetailInfo.methodHPLCInfo
                        .methodHPLCRTInfoList[0].tFlag,
                    Time: detail.methodDetailInfo.methodHPLCInfo
                      .methodHPLCRTInfoList[0].rt_time,
                    Percent:
                      detail.methodDetailInfo.methodHPLCInfo
                        .methodHPLCRTInfoList[0].percent,
                  });
                }
              }
              let solventLists = [];
              if (
                detail.methodDetailInfo.methodEluentSolventInfo
                  .eluent_solvent_channel_A != null
              ) {
                if (
                  detail.methodDetailInfo.methodEluentSolventInfo
                    .eluent_solvent_channel_A.solvent != null
                ) {
                  solventLists.push({
                    nameCh:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_A.solvent,
                    channel: "A",
                    polarity:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_A.polarity,
                    density:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_A.density,
                    id: detail.methodDetailInfo.methodEluentSolventInfo
                      .eluent_solvent_channel_A.solvent_id,
                  });
                }
              }
              if (
                detail.methodDetailInfo.methodEluentSolventInfo
                  .eluent_solvent_channel_B != null
              ) {
                if (
                  detail.methodDetailInfo.methodEluentSolventInfo
                    .eluent_solvent_channel_B.solvent != null
                ) {
                  solventLists.push({
                    nameCh:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_B.solvent,
                    channel: "B",
                    polarity:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_B.polarity,
                    density:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_B.density,
                    id: detail.methodDetailInfo.methodEluentSolventInfo
                      .eluent_solvent_channel_B.solvent_id,
                  });
                }
              }
              if (
                detail.methodDetailInfo.methodEluentSolventInfo
                  .eluent_solvent_channel_C != null
              ) {
                if (
                  detail.methodDetailInfo.methodEluentSolventInfo
                    .eluent_solvent_channel_C.solvent != null
                ) {
                  solventLists.push({
                    nameCh:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_C.solvent,
                    channel: "C",
                    polarity:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_C.polarity,
                    density:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_C.density,
                    id: detail.methodDetailInfo.methodEluentSolventInfo
                      .eluent_solvent_channel_C.solvent_id,
                  });
                }
              }
              if (
                detail.methodDetailInfo.methodEluentSolventInfo
                  .eluent_solvent_channel_D != null
              ) {
                if (
                  detail.methodDetailInfo.methodEluentSolventInfo
                    .eluent_solvent_channel_D.solvent != null
                ) {
                  solventLists.push({
                    nameCh:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_D.solvent,
                    channel: "D",
                    polarity:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_D.polarity,
                    density:
                      detail.methodDetailInfo.methodEluentSolventInfo
                        .eluent_solvent_channel_D.density,
                    id: detail.methodDetailInfo.methodEluentSolventInfo
                      .eluent_solvent_channel_D.solvent_id,
                  });
                }
              }
              let evaList = {};
              if (detail.methodDetailInfo.methodOtherInfo.evaluateset != "") {
                evaList = {
                  text1:
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo.evaluateset
                    ).text1 != undefined
                      ? JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.evaluateset
                        ).text1
                      : "",
                  text2:
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo.evaluateset
                    ).text2 != undefined
                      ? JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.evaluateset
                        ).text2
                      : "",
                };
              }
              let otherInfos = {};
              if (detail.methodDetailInfo.methodBaseInfo.otherinfo != "") {
                if (
                  JSON.parse(detail.methodDetailInfo.methodBaseInfo.otherinfo)
                    .solventsConsume.length > 0
                ) {
                  otherInfos = {
                    separateTime: JSON.parse(
                      detail.methodDetailInfo.methodBaseInfo.otherinfo
                    ).separateTime,
                    solventsConsume: JSON.parse(
                      detail.methodDetailInfo.methodBaseInfo.otherinfo
                    ).solventsConsume,
                  };
                } else {
                  otherInfos = {
                    separateTime: JSON.parse(
                      detail.methodDetailInfo.methodBaseInfo.otherinfo
                    ).separateTime,
                    solventsConsume: [
                      {
                        solvents: "",
                        vol: "",
                      },
                    ],
                  };
                }
              }
              let sampleList = {};
              if (
                detail.methodDetailInfo.methodBaseInfo.samplecollection !=
                  null &&
                detail.methodDetailInfo.methodBaseInfo.samplecollection != ""
              ) {
                sampleList = {
                  collectType: JSON.parse(
                    detail.methodDetailInfo.methodBaseInfo.samplecollection
                  ).collectType.toString(),
                  perCollectVol: JSON.parse(
                    detail.methodDetailInfo.methodBaseInfo.samplecollection
                  ).perCollectVol,
                };
              } else {
                sampleList = {
                  collectType: "",
                  perCollectVol: "",
                };
              }
              let purSolvents = [
                {
                  Percent: "",
                  Polarity: "",
                  Solvent: "",
                },
                {
                  Percent: "",
                  Polarity: "",
                  Solvent: "",
                },
              ];
              if (
                detail.methodDetailInfo.methodOtherInfo.purityresconfirmation !=
                ""
              ) {
                if (
                  typeof JSON.parse(
                    detail.methodDetailInfo.methodOtherInfo
                      .purityresconfirmation
                  ).tlc.solvents == "object"
                ) {
                  if (
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation
                    ).tlc.solvents.length > 0
                  ) {
                    purSolvents = JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation
                    ).tlc.solvents;
                  }
                }
              }
              let fA = "";
              let fB = "";
              let hplcA = [];
              let hplcB = [];
              if (
                JSON.parse(
                  detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                ).hplc.solvents != undefined
              ) {
                if (
                  JSON.parse(
                    detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                  ).hplc.solvents.length > 0
                ) {
                  if (
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                    ).hplc.solvents.length == 1
                  ) {
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].eluent_channel == 0
                    ) {
                      fA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].solvent;
                      hplcA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].solvent;
                      hplcB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].density,
                        eluent_channel: 1,
                      });
                    }
                  } else {
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].eluent_channel == 0
                    ) {
                      fA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].solvent;
                      hplcA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[0].solvent;
                      hplcB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[0].density,
                        eluent_channel: 1,
                      });
                    }
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[1].eluent_channel == 0
                    ) {
                      fA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[1].solvent;
                      hplcA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).hplc.solvents[1].solvent;
                      hplcB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).hplc.solvents[1].density,
                        eluent_channel: 1,
                      });
                    }
                  }
                }
              }
              let fpA = "";
              let fpB = "";
              let hplcpA = [];
              let hplcpB = [];
              if (
                JSON.parse(
                  detail.methodDetailInfo.methodOtherInfo.purityresconfirmation
                ).hplc.solvents != undefined
              ) {
                if (
                  JSON.parse(
                    detail.methodDetailInfo.methodOtherInfo
                      .purityresconfirmation
                  ).hplc.solvents.length > 0
                ) {
                  if (
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation
                    ).hplc.solvents.length == 1
                  ) {
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].eluent_channel == 0
                    ) {
                      fpA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].solvent;
                      hplcpA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fpB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].solvent;
                      hplcpB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].density,
                        eluent_channel: 1,
                      });
                    }
                  } else {
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].eluent_channel == 0
                    ) {
                      fpA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].solvent;
                      hplcpA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fpB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[0].solvent;
                      hplcpB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[0].density,
                        eluent_channel: 1,
                      });
                    }
                    if (
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[1].eluent_channel == 0
                    ) {
                      fpA = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[1].solvent;
                      hplcpA.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].density,
                        eluent_channel: 0,
                      });
                    } else {
                      fpB = JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation
                      ).hplc.solvents[1].solvent;
                      hplcpB.push({
                        Solvent: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].solvent,
                        id: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].solvent_id,
                        Polarity: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].polarity,
                        Density: JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).hplc.solvents[1].density,
                        eluent_channel: 1,
                      });
                    }
                  }
                }
              }
              // console.log("22",)
              console.log("22",typeof(Number(JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).type)))
              let infos = {
                Chromatographic:
                  detail.methodDetailInfo.methodBaseInfo.spectrum_pic,
                EvaluateSet: evaList,
                FlowRateList: "",
                GradientList:
                  detail.methodDetailInfo.methodGradientInfo
                    .methodGradientDetailList,
                MachineInfo:
                  detail.methodDetailInfo.methodOtherInfo.machineInfo != ""
                    ? JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.machineInfo
                      )
                    : "",
                MethodInfo: {
                  text3:
                    JSON.parse(detail.methodDetailInfo.methodBaseInfo.otherinfo)
                      .targetSample != undefined
                      ? JSON.parse(
                          detail.methodDetailInfo.methodBaseInfo.otherinfo
                        ).targetSample
                      : "",
                  yieldUnit:
                    JSON.parse(detail.methodDetailInfo.methodBaseInfo.otherinfo)
                      .yieldUnit != undefined
                      ? JSON.parse(
                          detail.methodDetailInfo.methodBaseInfo.otherinfo
                        ).yieldUnit
                      : "mg",
                  analysisColumn: "",
                  samplePeakAppearance: detail.methodDetailInfo.methodBaseInfo.samplePeakAppearance?detail.methodDetailInfo.methodBaseInfo.samplePeakAppearance:"",
                  atomizationTemperature:
                    detail.methodDetailInfo.methodBaseInfo.detectSetting != "0"
                      ? detail.methodDetailInfo.methodBaseInfo
                          .atomizationtemperature
                      : "",
                  collectionMode: "",
                  collectionThreshold: "",
                  columnDetail: {
                    flashColumn:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .flashColumn != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .flashColumn
                          : ""
                        : "",
                    cv:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo.cv !=
                          null
                          ? detail.methodDetailInfo.methodFlashColumnInfo.cv
                          : ""
                        : "",
                    filler:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .filler != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo.filler
                          : ""
                        : "",
                    aperture:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .aperture != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .aperture
                          : ""
                        : "",
                    catalogueName:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .catalogueName != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .catalogueName
                          : ""
                        : "",
                    particleSize:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .particleSize != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .particleSize
                          : ""
                        : "",
                    pressure:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .pressure != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .pressure
                          : ""
                        : "",
                    trailingFactorMin:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .trailingFactorMin != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .trailingFactorMin
                          : ""
                        : "",
                    trailingFactorMax:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .trailingFactorMax != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo
                              .trailingFactorMax
                          : ""
                        : "",
                    resolution: "",
                    supplierName: "",
                    length: "",
                    innerDiameter: "",
                    supplierId: "",
                    brand: "",
                    fillerLabel:
                      detail.methodDetailInfo.methodFlashColumnInfo != null
                        ? detail.methodDetailInfo.methodFlashColumnInfo
                            .filler != null
                          ? detail.methodDetailInfo.methodFlashColumnInfo.filler
                          : ""
                        : "",
                  },
                  create_time: "",
                  create_user: "",
                  detectSetting:
                    detail.methodDetailInfo.methodBaseInfo.detectsetting,
                  effectivePedals: "",
                  evaluate_level: "",
                  extract_user: "",
                  flashColumn:
                    detail.methodDetailInfo.methodFlashColumnInfo != null
                      ? detail.methodDetailInfo.methodFlashColumnInfo
                          .flashColumn
                      : null,
                  gradientType:
                    detail.methodDetailInfo.methodBaseInfo.gradient_type,
                  id: detail.id,
                  is_self: "",
                  loadAmount: detail.methodDetailInfo.methodBaseInfo.loadAmount,
                  loadAmountUnit:
                    detail.methodDetailInfo.methodBaseInfo.loadAmountUnit,
                  loadType: "",
                  method_location: "",
                  method_name:
                    detail.methodDetailInfo.methodBaseInfo.method_name,
                  method_security: "",
                  method_time: "",
                  method_type:
                    detail.methodDetailInfo.methodBaseInfo.method_type.toString(),
                  otherInfo: otherInfos,
                  project_uuid:
                    detail.methodDetailInfo.methodBaseInfo.method_uuid,
                  quote_number: "",
                  rawconPath: "",
                  resolution: "",
                  sampleCollection: sampleList,
                  sampleWeight: "",
                  solvents: solventLists,
                  spectrum_number: "",
                  trailingFactor: "",
                  uuid: "",
                  wavelengthChA:
                    detail.methodDetailInfo.methodBaseInfo
                      .wavelength_channel_1 == 0
                      ? ""
                      : detail.methodDetailInfo.methodBaseInfo
                          .wavelength_channel_1,
                  wavelengthChB:
                    detail.methodDetailInfo.methodBaseInfo
                      .wavelength_channel_2 == 0
                      ? ""
                      : detail.methodDetailInfo.methodBaseInfo
                          .wavelength_channel_2,
                },
                RFList: rfInfo,
                RTList: hplcInfo,
                SampleInfo: {
                  CAS: detail.methodDetailInfo.methodSampleInfo
                    .target_sample_list[0].sample_cas_info,
                  TargetPic:
                    detail.methodDetailInfo.methodSampleInfo
                      .target_sample_list[0].sample_pic,
                  TargetName:
                    detail.methodDetailInfo.methodSampleInfo
                      .target_sample_list[0].sample_name,
                  TargetSmiles:
                    detail.methodDetailInfo.methodSampleInfo
                      .target_sample_list[0].sample_smiles,
                },
                SamplePrepare: {},
                SolventList: solventsList,
                author:
                  detail.methodDetailInfo.methodOtherInfo.author != ""
                    ? JSON.parse(detail.methodDetailInfo.methodOtherInfo.author)
                    : {},
                baseInfo: {},
                id: "",
                purityResConfirmation: {
                  hplc: {
                    flashColumn: {
                      flow_rate:
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation != ""
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).hplc.analysisColumn != undefined
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .purityresconfirmation
                              ).hplc.analysisColumn.flowPhase
                            : ""
                          : "",
                      analysis_column:
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation != ""
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).hplc.analysisColumn != undefined
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .purityresconfirmation
                              ).hplc.analysisColumn.analysisName
                            : ""
                          : "",
                      particle_diameter:
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation != ""
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).hplc.analysisColumn != undefined
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .purityresconfirmation
                              ).hplc.analysisColumn.particleSize
                            : ""
                          : "",
                      inner_diameter:
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation != ""
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).hplc.analysisColumn != undefined
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .purityresconfirmation
                              ).hplc.analysisColumn.innerDiameter
                            : ""
                          : "",
                      length:
                        detail.methodDetailInfo.methodOtherInfo
                          .purityresconfirmation != ""
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).hplc.analysisColumn != undefined
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .purityresconfirmation
                              ).hplc.analysisColumn.length
                            : ""
                          : "",
                    },
                    hplcPic:
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation != ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .purityresconfirmation
                          ).hplc.hplcPic
                        : "",
                    flowA: fpA,
                    flowB: fpB,
                    hplcflowA: hplcpA,
                    hplcflowB: hplcpB,
                  },
                  tlc: {
                    label:
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation != ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .purityresconfirmation
                          ).tlc.tlcLabel == undefined
                          ? ""
                          : JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).tlc.tlcLabel
                        : "",
                    solvents: purSolvents,
                    tlcPic:
                      detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation != ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .purityresconfirmation
                          ).tlc.tlcPic == undefined
                          ? ""
                          : JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).tlc.tlcPic
                        : "",
                    remark:detail.methodDetailInfo.methodOtherInfo
                        .purityresconfirmation != ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .purityresconfirmation
                          ).tlc.remark == undefined
                          ? ""
                          : JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .purityresconfirmation
                            ).tlc.remark
                        : "",
                  },
                  type:
                    detail.methodDetailInfo.methodOtherInfo
                      .purityresconfirmation != ""
                      ? Number(JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo
                            .purityresconfirmation
                        ).type)
                      : "",
                },
                remark: "",
                sampleAnalysis: {
                  type:
                    detail.methodDetailInfo.methodOtherInfo.sampleanalysis !=
                      "" &&
                    JSON.parse(
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                    ).type != undefined
                      ? Number(JSON.parse(
                          detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                        ).type)
                      : 0,
                  tlc: {
                    tlcLabel:
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis !== ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.tlcLabel !== undefined
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .sampleanalysis
                            ).tlc.tlcLabel
                          : ""
                        : "",
                    solvents:
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis !== ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.solvents !== undefined
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .sampleanalysis
                            ).tlc.solvents
                          : []
                        : [],
                    tlcPic:
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis !== ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.tlcPic !== undefined
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .sampleanalysis
                            ).tlc.tlcPic
                          : ""
                        : "",
                    remark:
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis !==
                      ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.remark !== undefined
                          ? JSON.parse(
                              detail.methodDetailInfo.methodOtherInfo
                                .sampleanalysis
                            ).tlc.remark
                          : ""
                        : "",
                    tlcColorType:
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).tlc.tlcColorType !== undefined
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.tlcColorType
                        : "",
                    tlcColor:
                      JSON.parse(
                        detail.methodDetailInfo.methodOtherInfo.sampleanalysis
                      ).tlc.tlcColor !== undefined
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).tlc.tlcColor
                        : "",
                  },
                  hplc: {
                    flashColumn: {
                      flow_rate:
                        detail.methodDetailInfo.methodOtherInfo
                          .sampleanalysis != ""
                          ? Object.keys(
                              JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc
                            ).length != 0
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc.analysisColumn.flowPhase
                            : ""
                          : "",
                      analysis_column:
                        detail.methodDetailInfo.methodOtherInfo
                          .sampleanalysis != ""
                          ? Object.keys(
                              JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc
                            ).length != 0
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc.analysisColumn.analysisName
                            : ""
                          : "",
                      particle_diameter:
                        detail.methodDetailInfo.methodOtherInfo
                          .sampleanalysis != ""
                          ? Object.keys(
                              JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc
                            ).length != 0
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc.analysisColumn.particleSize
                            : ""
                          : "",
                      inner_diameter:
                        detail.methodDetailInfo.methodOtherInfo
                          .sampleanalysis != ""
                          ? Object.keys(
                              JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc
                            ).length != 0
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc.analysisColumn.innerDiameter
                            : ""
                          : "",
                      length:
                        detail.methodDetailInfo.methodOtherInfo
                          .sampleanalysis != ""
                          ? Object.keys(
                              JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc
                            ).length != 0
                            ? JSON.parse(
                                detail.methodDetailInfo.methodOtherInfo
                                  .sampleanalysis
                              ).hplc.analysisColumn.length
                            : ""
                          : "",
                    },
                    hplcPic:
                      detail.methodDetailInfo.methodOtherInfo.sampleanalysis !==
                      ""
                        ? JSON.parse(
                            detail.methodDetailInfo.methodOtherInfo
                              .sampleanalysis
                          ).hplc.hplcPic
                        : "",
                    flowA: fA,
                    flowB: fB,
                    hplcflowA: hplcA,
                    hplcflowB: hplcB,
                  },
                },
                startObjects: startobject,
              };
               console.log('infos',infos)
              return {
                id: detail.id,
                createTime: detail.createTime,
                toName: detail.toName,
                toCas: detail.toCas,
                infos: infos,
                status: detail.status,
                samplePic: detail.samplePic,
                deptName: detail.deptName,
              };
            });
          } else {
            this.$message({
              type: "warning",
              message: "Get Data failed!",
            });
          }
        }
      );
    },
    getMethodsCount: function () {
      let _this = this;
      let conditionJSON = this.genMethodsSearchCondition();
      let username = this.$cookie.get("userId");
      this.$api.post(
        "/datacenter/countSepaMethodsByUser",
        {
          username: username,
          condition: conditionJSON,
        },
        (res) => {
          // console.log(res)
          if (res.data.code == 200) {
            _this.totalSize = res.data.data;
          } else {
            _this.$message({
              type: "warn",
              message: "获取合成方法数量失败!",
            });
          }
        }
      );
    },
    setDetailForm: function (infos, status, id) {
      console.log(infos)
      this.$store.state.sepaMethods.editId = id;
      this.$store.state.sepaMethods.stateValue = status;
      this.detailForm = infos;
      if (this.detailForm.startObjects == undefined) {
        this.detailForm.startObjects = [
          {
            name: "",
            cas: "",
            png: "",
          },
        ];
      }
      // console.log(this.detailForm);
      this.showDetailDialog = true;
      if (status == 0 || status == 3) {
        this.showState = true;
      } else {
        this.showState = false;
      }
    },
    editInfos: function (infos) {
      this.$store.state.sepaMethods.edit = true;
      console.log("modi", infos);
      // console.log('Edit Infos');
      // console.log(infos);
      this.updateSepaMethod(infos);
      this.$store.commit("updateInfoForm", infos);
      this.$store.commit("updateTabs", {
        tag: "add",
        tab: {
          title: "录入分离方法",
          name: "9-1",
        },
      });
    },
    formatTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    inputChange() {
      if (this.searchCondition.targetObjectName == "") {
        this.targetUrl = "";
      }
    },
    inputnDeptNameChange() {
      if (this.searchCondition.deptName == "") {
        this.deptName = "";
      }
    },
    inputStartChange() {
      if (this.searchCondition.startObjectName == "") {
        this.startUrl = "";
      }
    },
    pageChange: function (val) {
      this.page = val;
      this.searchSepeMethods();
    },

    updateMethodState: function (id, state) {
      if (state == 1) {
        this.tipContent = "确认上传？";
      } else if (state == 4) {
        this.tipContent = "确认上架？";
      } else if (state == 2) {
        this.tipContent = "确认下架？";
      }
      this.$confirm(this.tipContent, "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        // 用户确认删除后的操作
        .then(() => {
          let _this = this;
          this.$api.post(
            "datacenter/updateSepMethodsState",
            {
              id: id,
              state: state,
              username: this.$cookie.get("userId"),
            },
            (res) => {
              if (res.data.data.code == 200) {
                // if (state === 0) {
                //     _this.$message({
                //     type: 'info',
                //     message: '成功下线分离方法!'
                // });
                // }
                // else {
                _this.$message({
                  type: "info",
                  message: "成功!",
                });
                // }
                _this.searchSepeMethods();
              } else {
                _this.$message({
                  type: "error",
                  message: `${res.data.data.msg}`,
                });
              }
            }
          );
        })
        .catch(() => {});
    },
    deleteSepMethods: function (id) {
      this.$confirm("确定删除该分离方法吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.get(
            "datacenter/deleteSepeMethodById",
            {
              id: id,
            },
            (res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "成功删除合成方法",
                });
                this.searchSepeMethods();
              }
            }
          );
        })
        .catch(() => {});
    },
    ...mapActions("sepaMethods", ["updateSepaMethod"]),
  },
  mounted() {
    this.searchSepeMethods();
  },
};
</script>

<style scoped>
.cell i {
  font-size: 25px;
}
.img-size {
  max-width: 400px;
  max-height: 300px;
}
::v-deep .dialog {
  width: 850px !important;
  height: 800px !important;
}
</style>
